import { Frame, Scene } from 'dragonmouse-shared/interfaces';
import { setLoadingState, updateGuestFrames, updateGuestScenes } from 'redux/db/actions';
import store from 'redux/store';
import { VITE_FORGE_URL } from '../constants';
import { PollingStream } from './PollingStream';

interface SessionPollData {
	guestScenes: Scene[];
	guestFrames: Frame[];
	timestamp: string | null;
}

export class SessionPollingStream extends PollingStream<SessionPollData> {
	constructor() {
		const url = VITE_FORGE_URL + '/poll/session';

		const onError = (error: Error) => {
			console.error('Session polling stream error:', error);
			store.dispatch(updateGuestScenes([]));
			store.dispatch(updateGuestFrames([]));
		};

		super(url, onError);
	}

	extractData(response: any): SessionPollData[] {
		// Session endpoint returns an object with guestScenes and guestFrames
		if (!response) {
			return [];
		}
		return [response];
	}

	onData(sessionDataArray: SessionPollData[]) {
		if (sessionDataArray.length === 0) {
			store.dispatch(updateGuestScenes([]));
			store.dispatch(updateGuestFrames([]));
			store.dispatch(setLoadingState({ resource: 'guest.scenes', state: 'loaded' }));
			store.dispatch(setLoadingState({ resource: 'guest.frames', state: 'loaded' }));
			return;
		}

		const sessionData = sessionDataArray[0];

		// Update guest scenes
		const scenes: Scene[] = sessionData.guestScenes.map((scene) => ({
			id: scene.id,
			title: scene.title,
			metadata: scene.metadata,
			createdAt: new Date(scene.createdAt),
			updatedAt: scene.updatedAt ? new Date(scene.updatedAt) : undefined,
			writeId: scene.writeId,
			viewOnly: true,
		}));

		// Update guest frames
		const frames: Frame[] = sessionData.guestFrames.map((frame) => ({
			id: frame.id,
			sceneId: frame.sceneId,
			title: frame.title,
			x: frame.x,
			y: frame.y,
			width: frame.width,
			height: frame.height,
			imagePath: frame.imagePath,
			siteId: frame.siteId,
			entries: frame.entries,
			metadata: frame.metadata,
			createdAt: new Date(frame.createdAt),
			updatedAt: frame.updatedAt ? new Date(frame.updatedAt) : undefined,
			deletedAt: frame.deletedAt ? new Date(frame.deletedAt) : null,
			writeId: frame.writeId,
			viewOnly: true,
		}));

		store.dispatch(updateGuestScenes(scenes));
		store.dispatch(updateGuestFrames(frames));
		store.dispatch(setLoadingState({ resource: 'guest.scenes', state: 'loaded' }));
		store.dispatch(setLoadingState({ resource: 'guest.frames', state: 'loaded' }));
	}
}
